export const STOPE_SHAPE_COLOURS = {
  completed: '#2f9e44',
  active: '#1c7ed6',
  planned: '#f59f00',
  idle: '#8a8f98',
};

export const STOPE_SHAPE_OPACITY = {
  completed: 0.42,
  active: 0.42,
  planned: 0.36,
  idle: 0.22,
};

export const MAX_STOPE_SHAPE_OPACITY = Math.max(...Object.values(STOPE_SHAPE_OPACITY));
export const DEFAULT_STOPE_SHAPE_OPACITY = MAX_STOPE_SHAPE_OPACITY;
